<template>
  <div class="player-schedule" :class="{nonPadding: !seasonType.schedule}">
    <div v-if="seasonType.schedule">
      <DateSlider :year-state="true" :month-state="true" @year="yearChange" @month="monthChange" :active-month="month"/>

      <div v-if="scheduleList.length" class="schedule-list">
        <ul v-for="(item, index) in scheduleList" :key="index" :class="{current: item.current}">
          <li>
            <p class="date">{{item.dayNum}}</p>
            <p class="day">{{item.day}}</p>
          </li>
          <li class="line"></li>
          <li>
            <p class="title">{{item.title}}</p>
            <p class="time-place">
              <span class="time">{{item.time}}</span><span class="place">{{item.content}}</span>
            </p>
          </li>
        </ul>
      </div>
      <div v-else class="content-empty">
        내용 준비 중입니다.
      </div>
    </div>
    <div v-else>
      <PageComingSoon :titleText="' '" :descriptionText="String(seasonMsg)" />
    </div>
  </div>
</template>

<script>
import DateSlider from '@/components/Common/DateSlider.vue';
import PageComingSoon from '@/components/Common/PageComingSoon.vue';
import dayjs from "dayjs";

export default {
  name: 'PlayerSchedule',
  components: {DateSlider, PageComingSoon},
  data() {
    return {
      scheduleList: [],
      currentDate: this.$store.state.currentDate,
      year: dayjs().format('YYYY'),
      month: dayjs().format('MM'),
      seasonType: this.$store.getters['getSeasonType'],
      seasonMsg: this.$store.getters['getSeasonMsg'],
    }
  },
  mounted () {
    this.getSchedule();
  },
  methods: {
    async getSchedule() {
      const {data} = await this.$http.get(`/player/calendar?year=${this.year}&month=${this.month}`)
      if(data.success) {
        this.scheduleList = data.data;
      }

      this.scheduleList.map(item => {
        item.dayNum = dayjs(item.date).format('DD');
        item.day = dayjs(item.date).format('ddd');
        if(this.currentDate === item.date) {
          item.current = true;
        }
        item.place = item.place ? item.place : '-';
      })
    },
    yearChange(data) {
      // console.log('yearChange : ', data);
      this.year = data;
    },
    monthChange(data) {
      // console.log('monthChange : ', data);
      this.month = data;
      this.getSchedule();
    },
  }
}
</script>
<style scoped>
.nonPadding {
  padding: 0 !important;
}
.content-empty {
  padding: 20px;
  text-align: center;
  font-size: 14px;
  color: #999;
}
</style>
